import React from 'react'

import { sexList } from '../../data'

export default function SexLabel({ value }) {
    const obj = sexList.find(item => item.value === value)
    if (!obj) return null
    return (
        <> {obj.label} </>
    )
}
